export default [
  {
    title: "Chapter Director",
    name: "Rich Morris",
    email: "cd@il-chapter-z.org",
    photo: "Rich_Morris",
  },
  {
    title: "Treasurer",
    name: "Wendy Stark",
    email: "treasurer@il-chapter-z.org",
    photo: "waiting-on-photo",
  },
  {
    title: "Ride Coordinator",
    name: "Brian King",
    email: "rides@il-chapter-z.org",
    photo: "Brian_King",
  },
  {
    title: "Membership Development",
    name: "John & Julie Nixon",
    email: "mec@il-chapter-z.org",
    photo: "John_Julie_Nixon",
  },
  // {
  //   title: "Assistant Ride Coordinator",
  //   name: "Brian King",
  //   email: "arc@il-chapter-z.org",
  //   photo: "Brian_King",
  // },
  {
    title: "Newsletter Editor",
    name: "Randy House",
    email: "newsletter@il-chapter-z.org",
    photo: "waiting-on-photo",
  },
  {
    title: "Sunshine",
    name: "Melody Sledgister",
    email: "sunshine@il-chapter-z.org",
    photo: "waiting-on-photo",
  },
];
